import React, { Component } from 'react';
import { DraggableWindow } from '../DraggableWindow';

import { LayoutContext } from '../../../../modules/ContextModules/LayoutContext';
import { TravelDiaryToolItem } from './TravelDiaryToolItem/TravelDiaryToolItem';
import { TravelDiaryListItem } from './TravelDiaryListItem/TravelDiaryListItem';

import ApiOviewDocmd from '../../../../modules/WebApiModules/ApiOviewDocmd';

import exifr from 'exifr';
import ls from 'localstorage-slim';

import shared from './.image/sharedURL.png';
import outputVideo from './.image/outputVideo.png';
import locate from './.image/locate-2.png';
import group from './.image/group.png';
import picture from './.image/picture.png';
import pictureBorder from './.image/pictureBorder.png';
import loading from './.image/loading.gif';
//import head from './.image/預設頭像.png';
//import glb from './.image/小黃人.glb';
import yellowMan from "./YellowMan.js";
import './TravelDiaryTool.css'

const engine = window.GetEPSGEngine();
export class TravelDiaryTool extends Component {
    static contextType = LayoutContext;

    constructor(props) {
        super(props);

        this.state = {
            demoName: "南投好行範例Demo",
            pageName: "日記",
            gpxFileName: "",
            nowTrack: undefined,
            nowPicture: picture,
            waitPicList: [],
            nowTrackIndex: -1,
            showTrackList: [],
            uploadLoading: false,
            picFileName: "",
            showPicIndex: -1,
            describe: "",
            textEdit: false,
            picEdit: false,
            picTitle: "",
            picText: "",
            changeView: true,
            isLogined: false,
        }

        this.token = "";

        this.demoIndex = -1;    //範例索引

        this.trackLoading = false;
        this.listLoading = false;

        this.trackList = [];        //軌跡清單
        this.nowEntityList = [];    //軌跡事件圖素清單
        this.nowEntityTimeList = [];  //軌跡事件圖素所在時間列表
        this.nowPicList = [];       //日記資料列表

        this.trackTimeEvent = -1;   //軌跡時間軸事件索引

        this.startVideo = false;    //判斷是否錄影
        this.isPause = false;       //判斷是否時間中斷

        this.recordTimeEvent = undefined;   //錄影事件
        this.recordTimelineEvent = -1;

        this.track = window.gMainMap.TerrainView.getModule("track");
        this.track.depthTest = true;

        this.collisionList = [];    //碰撞列表 避免重複碰撞

        this.cameraHeight = 4;
    }

    async componentDidMount() {
        this.listLoading = true;
        this.custom = await this.GetCustomDrawLayer();
        this.customPic = await this.GetCustomDrawPicLayer();
        this.getAllTrack();

        let lsInfo = ls.get("userInfo", { decrypt: true });
        if (lsInfo) {
            this.setState({ isLogined: true });
        }
    }

    componentWillUnmount() {
        const { travelDiaryToolContext } = this.context;

        this.Async_WaitMapInit().then(() => {
            travelDiaryToolContext.update({ token: "" });
            window.gMainMap.TerrainView.removeLayer(this.custom);
            this.removeTrack();
            window.gMainMap.TerrainView.removeTimeEvent(this.trackTimeEvent);
            window.gMainMap.TerrainView.removeLayer(this.custom);
            window.gMainMap.TerrainView.removeLayer(this.customPic);
        });

        if (this.recordTimeEvent) {
            clearInterval(this.recordTimeEvent);
        }
    }

    //移除時間條
    removeWidgetTimeline() {
        this.widgetTimeline && this.widgetTimeline.remove();
        this.widgetTimelinePlayer && this.widgetTimelinePlayer.remove();
    }

    //繪出叢集
    async paintCluster() {
        //根節點參數
        let rootParam = {
            geo: new GeoPoint(123, 25),
            absHeight: false,
            epsg: 4326,
            symbol: group,
            pullUpY: 500,
            size: 50,
            displayLeafCount: true,
            attr: "點擊資訊",
            childrenCluster: true,
            childrenGridSize: 64,
            childrenMaxSize: 0,
            children: []
        };

        let lon = 0;
        let lat = 0;

        this.trackList.forEach((track, index) => {
            if (index !== this.state.nowTrackIndex && this.state.showTrackList[index]) {
                let longitude = parseFloat(track.pos.x);
                let laitude = parseFloat(track.pos.y);
                let text = track.name;
                let attr = index;

                if (!(isNaN(longitude) || isNaN(laitude))) {
                    lon += longitude;
                    lat += laitude;
                    //葉節點參數
                    let param = {
                        geo: new GeoPoint(longitude, laitude),
                        epsg: 4326,
                        label: {
                            text: text,
                            font: "標楷體"
                        },
                        symbol: locate,
                        size: 50,
                        pullUpY: 1000,
                        pullUpYIsWorldSize: true,
                        attr: attr,
                        tooltip: text
                    };

                    //推入根節點children
                    let length = this.trackList.length;
                    if (length > 0) {
                        rootParam.geo = new GeoPoint(lon / length, lat / length);
                    }
                    rootParam.children.push(param);
                }
            }
        });

        this.clusterEntity = this.custom.addClusterEntity(rootParam);

        //點擊事件 顯示軌跡
        this.clusterEntity.setOnClickListener(function (mousePos, attr, sn, name) {

            if (attr.type !== ov.ENUM_VECTOR_ENTITY_TYPE.CLUSTER && !this.trackLoading) {
                let index = parseInt(attr.attr);
                this.trackLoading = true;
                this.getTrack(index);
            }
        }.bind(this));
    }

    //取得軌跡
    getTrack(index) {
        let name = this.trackList[index].name;
        let date = this.trackList[index].date;
        let dir = this.trackList[index].dir;
        ApiOviewDocmd.Docmd("CMD_GetTrack", { name: name, date: date, dir: dir }, (res) => {
            this.nowPicList = res.picList;
            this.nowEntityList = [];
            this.nowEntityTimeList = [];
            this.collisionList = [];
            let nowTrack = res.track;
            this.setState({
                nowTrackIndex: index,
                nowTrack: nowTrack,
                showPicIndex: -1,
                describe: nowTrack.describe,
                picTitle: "",
                picText: "",
                textEdit: false,
                picEdit: false
            }, async () => {
                await this.addTrack(this.state.nowTrack.gpxFile, name);

                this.nowPicList.forEach((ent, index) => {
                    let pa = this.paintEvent(ent.geo, ent.pic, index);
                    this.addPicTimeList(ent.geo);
                    this.nowEntityList.push(pa);
                });

                this.trackLoading = false;
                this.paintCluster();
            });

        }, (res) => { this.trackLoading = false; console.log(res); });
    }

    async Async_WaitMapInit() {
        if (window.gMainMap.IsReady) {
            return;
        }
        function Wait(time) {
            return new Promise((rs) => { setTimeout(rs, time ?? 100) })
        }
        while (!window.gMainMap.IsReady) {
            await Wait();
        }
    }

    async Async_WaitListLoading() {
        if (!this.listLoading) {
            return;
        }
        function Wait(time) {
            return new Promise((rs) => { setTimeout(rs, time ?? 100) })
        }
        while (this.listLoading) {
            await Wait();
        }
    }

    /**取得自畫圖層 軌跡點*/
    async GetCustomDrawLayer() {
        await this.Async_WaitMapInit();
        const CustDrawLayerID = "_CustomTravelDiaryTrack";
        let layer = window.gMainMap.TerrainView.findLayer(CustDrawLayerID);
        if (!layer) {
            layer = window.gMainMap.TerrainView.addCustomLayer(CustDrawLayerID);
            layer.setDepthTest(true);
        }

        return layer;
    }

    /**取得自畫圖層 日記點*/
    async GetCustomDrawPicLayer() {
        await this.Async_WaitMapInit();
        const CustDrawLayerID = "_CustomTravelDiaryPicture";
        let layer = window.gMainMap.TerrainView.findLayer(CustDrawLayerID);
        if (!layer) {
            layer = window.gMainMap.TerrainView.addCustomLayer(CustDrawLayerID);
            layer.setDepthTest(true);
            layer.setDepthFunc(519);
        }

        return layer;
    }

    //選擇gpx檔案 
    async gpxFile_OnChange(e) {
        if (e.target.files.length < 1) {
            window.alertify.log("請選擇檔案。");
            return;
        }

        let file = e.target.files[0];

        await this.Async_WaitMapInit();
        await this.Async_WaitListLoading();

        for (let i = 0; i < this.trackList.length; i++) {
            if (file.name === this.trackList[i].name) {
                window.alertify.error("檔案名稱重複。");
                return;
            }
        }

        const promise = new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = function () {
                let res = reader.result;
                resolve(res);
            }
            reader.readAsDataURL(file);
        });
        let uploadData = await promise;

        let position = await this.addTrack(uploadData, file.name);

        let track = {
            gpxFile: uploadData,
            name: file.name,
            pos: position,
            describe: "",
            dir: "",
            enable: true
        }

        //清空日記列表
        this.nowEntityList = [];
        this.nowEntityTimeList = [];
        this.nowPicList = [];

        this.collisionList = [];

        this.setState({
            nowTrack: track,
            nowTrackIndex: -1,
            gpxFileName: file.name,
            describe: "",
            picTitle: "",
            picText: "",
            showPicIndex: -1
        }, () => { this.paintCluster(); });
    }

    //上傳軌跡
    uploadTrack_OnClick() {
        this.setState({ uploadLoading: true });
        ApiOviewDocmd.Docmd("CMD_UploadTrack", { track: this.state.nowTrack }, (res) => {
            let track = this.state.nowTrack;
            let index = this.state.nowTrackIndex;
            let showTrackList = this.state.showTrackList;
            if (track.dir === "") {
                this.trackList.push(res.trackEntity);
                index = this.trackList.length - 1;
                track.dir = res.trackEntity.dir;
                showTrackList[index] = true;
            }

            if (track.name.substring(0, track.name.length - 4) === (this.state.demoName)) {
                this.demoIndex = index;
            }

            this.nowPicList.forEach(pic => {
                if (pic.update) {
                    pic.update = false;
                    this.picUpload(pic, track.dir);
                }
            });

            this.setState({
                nowTrack: track, nowTrackIndex: index,
                showTrackList: showTrackList,
                uploadLoading: false,
                textEdit: false,
                picEdit: false,
                picFileName: ""
            }, () => { this.paintCluster(); });
        }, (res) => { console.log(res); });
    }

    //刪除軌跡
    deleteTrack_OnClick() {
        ApiOviewDocmd.Docmd("CMD_DeleteTrack", { dir: this.state.nowTrack.dir }, (res) => {
            this.nowEntityList = [];
            this.nowPicList = [];       //日記資料列表
            this.removeTrack();         //清除軌跡
            this.trackList.splice(this.state.nowTrackIndex, 1);
            let showTrackList = this.state.showTrackList;
            showTrackList.splice(this.state.nowTrackIndex, 1);

            this.trackList.forEach((track, index) => {
                if (track.name.substring(0, track.name.length - 4) === (this.state.demoName)) {
                    this.demoIndex = index;
                }
            });

            this.setState({
                nowTrackIndex: -1,
                nowTrack: undefined,
                showTrackList: showTrackList,
                gpxFileName: "",
                showPicIndex: -1,
                describe: "",
                picTitle: "",
                picText: ""
            }, () => {
                this.custom.removeAllEntity();
                this.customPic.removeAllEntity();
                this.paintCluster();
            });

        }, (res) => { console.log(res); });
    }

    //登入使用者刪除軌跡
    loginUserDelete_OnClick(name) {
        ApiOviewDocmd.Docmd("CMD_LoginUserDeleteTrack", { name: name }, (res) => {
            let delTrackIndex = -1;
            this.trackList.forEach((track, index) => {
                if (track.name === name) {
                    delTrackIndex = index;
                }
            });

            this.nowEntityList = [];
            this.nowPicList = [];       //日記資料列表
            this.removeTrack();         //清除軌跡
            this.trackList.splice(delTrackIndex, 1);
            let showTrackList = this.state.showTrackList;
            showTrackList.splice(delTrackIndex, 1);

            this.trackList.forEach((track, index) => {
                if (track.name.substring(0, track.name.length - 4) === (this.state.demoName)) {
                    this.demoIndex = index;
                }
            });

            this.setState({
                nowTrackIndex: -1,
                nowTrack: undefined,
                showTrackList: showTrackList,
                gpxFileName: "",
                showPicIndex: -1,
                describe: "",
                picTitle: "",
                picText: ""
            }, () => {
                this.custom.removeAllEntity();
                this.customPic.removeAllEntity();
                this.paintCluster();
            });

        }, (res) => { console.log(res); });
    }

    //清除軌跡
    removeTrack() {
        this.isPause = false;

        if (this.GPXEntity) {
            this.track.removeEntity(this.GPXEntity);
        }
        if (this.widgetTimelinePlayer) {
            this.widgetTimelinePlayer.stop();
        }
        this.removeWidgetTimeline();
        window.gMainMap.TerrainView.removeTimeEvent(this.recordTimelineEvent);
    }

    //加入軌跡
    async addTrack(gpxfile, fileName) {
        let file = this.dataURLtoFile(gpxfile, fileName);
        this.custom.removeAllEntity();
        this.customPic.removeAllEntity();
        this.removeTrack();
        this.widgetTimeline = new window.ov.Widget.Timeline({ view: window.gMainMap.TerrainView, style: { left: "70px", width: "calc(80% - 70px)", bottom: "100px" } });
        this.widgetTimelinePlayer = new window.ov.Widget.TimelinePlayer({
            view: window.gMainMap.TerrainView,
            style: { bottom: "50px" },
            timeline: this.widgetTimeline,
            playSpeed: 4,
            minUpdateInterval: 1
        });
        //console.log(this.widgetTimeline);
        //console.log(this.widgetTimelinePlayer);

        let position = await new Promise(function (rs) {
            this.track.addGPXEntity({
                onGround: true,
                source: file,
                target: { src: yellowMan, scale: 1, minRange: 0, rotate: { x: 0, y: 1, z: 0, w: 270 }, absHeight: false },
                callback: function (ent) {
                    this.widgetTimeline.addLink(ent);
                    this.GPXEntity = ent;

                    this.goto(ent.position.x, ent.position.y);
                    this.GPXEntity.show = false;

                    try {
                        //ent._entity._Layer._Entities[1].UpdateParameter({ pointOffset: new GeoPoint(0, 25), symbolSize: [50, 50] });
                        ent._entity._Layer._Entities[0].UpdateParameter({ color: "rgb(255, 251, 0)", size: 5, dashScale: 0 });
                        // ent._entity._TargetEntity._Text._FontSize = 0;
                    } catch (error) {
                        console.log(error);
                        console.log(ent);
                    }
                    let position = ent.position;
                    let p = new window.GeoPoint(position.x, position.y);
                    this.moveLine = this.custom.addGroundPolylineEntity({ geo: new window.GeoPolyline([p, p]), color: "rgb(255, 251, 0)", size: 5 });
                    rs(ent.position);
                    this.widgetTimeline.updateTime(ent.playingInfo.TimeSpan[0]);
                    this.widgetTimeline.updateParameter({ startTime: ent.playingInfo.TimeSpan[0], stopTime: ent.playingInfo.TimeSpan[1], isRepeat: true });
                    this.addTrackTimeEvent();
                    let rate = Math.round(this.getTimeRate(this.GPXEntity.getParameter().path.geo, this.GPXEntity.getParameter().path.date));
                    this.cameraHeight = 4;
                    this.widgetTimelinePlayer.updateParameter({ playSpeed: rate });
                }.bind(this)
            });
        }.bind(this))

        return position;
    }

    //將base64轉換為檔案
    dataURLtoFile(dataurl, filename) {
        let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    //軌跡時間軸事件
    addTrackTimeEvent() {
        if (this.trackTimeEvent !== -1) {
            window.gMainMap.TerrainView.removeTimeEvent(this.trackTimeEvent);
        }
        if (this.GPXEntity) {
            this.trackTimeEvent = window.gMainMap.TerrainView.addTimeEvent({
                start: this.GPXEntity.playingInfo.TimeSpan[0],
                end: this.GPXEntity.playingInfo.TimeSpan[1],
                onPlay: function () {
                    if (this.GPXEntity) {
                        let dates = this.GPXEntity.getParameter().path.date;
                        let geo = this.GPXEntity.getParameter().path.geo;
                        this.cameraMove(dates, geo);
                        this.checkCollision();
                        this.dashLineToSolid(dates, geo);
                    }
                }.bind(this),
                onEnter: function () {
                    this.nowEntityList.forEach(entity => {
                        entity.point.show = true;
                    });
                }.bind(this),
                onLeave: function () {
                    this.nowEntityList.forEach(entity => {
                        entity.point.show = false;
                        entity.border.show = false;
                        entity.picture.show = false;
                        entity.text.show = false;
                        this.setState({ showPicIndex: -1, picTitle: "", picText: "", picText: "", nowPicture: picture });
                    });
                }.bind(this)
            });
        }
    }

    //第三人稱攝影機移動
    cameraMove(dates, geo) {
        if (this.widgetTimelinePlayer._Play) {
            let height = window.gMainMap.TerrainView.getHeight(this.GPXEntity.position);
            let pos = new window.GeoPoint(this.GPXEntity.position.x, this.GPXEntity.position.y, height + 4);
            let oldV = window.gMainMap.TerrainView.camera.v;
            for (let i = 0; i < dates.length - 1; i++) {
                if (this.GPXEntity.playTime > dates[i] && this.GPXEntity.playTime < dates[i + 1]) {
                    let x = geo[i + 1].x - geo[i].x;
                    let y = geo[i + 1].y - geo[i].y;
                    let z = geo[i + 1].z - geo[i].z;

                    let vector = this.normalize({ x: x, y: y, z: z });

                    // 計算角度
                    let angle = this.computeAng(vector, oldV);
                    let newV = window.gMainMap.TerrainView.camera.v;
                    let up = new window.Geo3DPoint(0, 0, 1);
                    let r = this.cross(newV, up);
                    if (!isNaN(angle)) {
                        //判斷轉動方向

                        let divide = 30
                        //計算與r夾角以確定轉向左邊或右邊
                        let ang2 = this.computeAng(vector, r);

                        if (ang2 > 90) {
                            angle *= -1;
                        }
                        let rate = this.computeDis(geo[i + 1], pos) / this.computeDis(geo[i + 1], geo[i]);
                        rate = rate.toFixed(2);
                        newV = this.rotateVectorXY(angle / (divide + 50 * (1 - rate)));
                    }

                    let cameraV = new window.Geo3DPoint(newV.x, newV.y, 0);
                    engine.Transfer(4326, 3857, pos);
                    engine.Transfer(4326, 3857, cameraV);
                    cameraV.Normalize();
                    let newPos = new window.GeoPoint(pos.x - cameraV.x * 20, pos.y - cameraV.y * 20, pos.z);
                    engine.Transfer(3857, 4326, newPos);
                    let newHeight = window.gMainMap.TerrainView.getHeight(newPos);
                    engine.Transfer(4326, 3857, newPos);
                    if (newHeight - height <= 0) {
                        if (this.cameraHeight > 4) {
                            this.cameraHeight -= 0.1;
                        }
                    }
                    else if (newHeight - height > 4) {
                        if (this.cameraHeight < 10) {
                            this.cameraHeight += 0.1;
                        }
                    }

                    newPos.z = newHeight + this.cameraHeight;

                    let temp = new window.Geo3DPoint(0, 0, 1);
                    let cameraR = this.cross(cameraV, temp);
                    cameraR.Normalize();
                    cameraV = new window.Geo3DPoint(cameraV.x * 20, cameraV.y * 20, pos.z - newPos.z);
                    cameraV.Normalize();
                    let cameraUp = this.cross(cameraR, cameraV);

                    engine.Transfer(3857, 4326, newPos);

                    let newCamera = new window.ov.Camera(newPos, cameraV, cameraUp);
                    window.gMainMap.TerrainView.gotoCamera(newCamera, false);
                    break;
                }
            }
        }
    }

    //經過後虛線變為實線
    dashLineToSolid(dates, geo) {
        if (this.widgetTimelinePlayer._Play) {
            let geoList = [];
            let hasPassList = [];
            for (let i = 0; i < dates.length - 1; i++) {
                hasPassList.push(new window.GeoPoint(geo[i].x, geo[i].y));
                geoList.push(new window.GeoPoint(geo[i].x, geo[i].y));
                if (this.GPXEntity.playTime > dates[i] && this.GPXEntity.playTime < dates[i + 1]) {
                    geoList.push(new window.GeoPoint(this.GPXEntity.position.x, this.GPXEntity.position.y));
                    hasPassList.push(new window.GeoPoint(this.GPXEntity.position.x, this.GPXEntity.position.y));
                    for (let j = i + 1; j < dates.length; j++) {
                        geoList.push(new window.GeoPoint(geo[j].x, geo[j].y));
                    }
                    if (this.moveLine) {
                        this.moveLine.update({ geo: new window.GeoPolyline(hasPassList) });
                    }
                    this.GPXEntity._entity._Layer._Entities[0].UpdateParameter({ geo: new window.GeoPolyline(geoList) });
                    break;
                }
            }
        }
    }

    //時間與位置碰撞檢查
    checkCollision() {
        let nowDate = this.GPXEntity.playTime;

        if (this.widgetTimelinePlayer._Play) {
            let lastIndex = -1;
            let alreadyPass = [];

            for (let index = 0; index < this.nowEntityTimeList.length; index++) {
                if (nowDate >= this.nowEntityTimeList[index] && !this.collisionList.includes(index)) {
                    alreadyPass.push(index);
                }

                if (nowDate < this.nowEntityTimeList[index] && this.collisionList.includes(index)) {
                    this.collisionList.splice(this.collisionList.indexOf(index), 1);
                }
            }

            let maxDate = new Date(0);
            alreadyPass.forEach(passTimeIndex => {
                if (this.nowEntityTimeList[passTimeIndex] >= maxDate) {
                    if (lastIndex !== -1) {
                        this.collisionList.push(lastIndex);
                    }
                    maxDate = this.nowEntityTimeList[passTimeIndex];
                    lastIndex = passTimeIndex;
                }
                else {
                    this.collisionList.push(passTimeIndex);
                }
            });

            if (lastIndex !== -1 && !this.collisionList.includes(lastIndex)) {
                this.collisionList.push(lastIndex);

                let nowPos = this.GPXEntity.position;
                let picGeo = this.nowPicList[lastIndex].geo

                if (nowDate.getTime() - this.nowEntityTimeList[lastIndex].getTime() <= 10000) {//單位是毫秒數
                    this.showEntity(lastIndex);
                    this.isPause = true;
                    this.widgetTimelinePlayer.stop();

                    let moveV = new window.Geo3DPoint(picGeo.x - nowPos.x, picGeo.y - nowPos.y, 0)

                    let oldCamera = window.gMainMap.TerrainView.camera;
                    let newCameraPos = new window.GeoPoint(oldCamera.pos.x + moveV.x, oldCamera.pos.y + moveV.y, 0);
                    let newCameraHeight = window.gMainMap.TerrainView.getHeight(newCameraPos);
                    newCameraPos.z = newCameraHeight + this.cameraHeight;

                    let newCamera = new window.ov.Camera(newCameraPos, oldCamera.v, oldCamera.up);
                    window.gMainMap.TerrainView.gotoCamera(newCamera, false);

                    setTimeout(() => { this.showEntity(lastIndex); }, 4001);
                    setTimeout(() => {
                        this.widgetTimelinePlayer.play();
                        this.isPause = false;
                    }, 4000);
                }
            }
        }
    }

    //計算時間速率
    getTimeRate(geos, dates) {
        let defaultSpeed = 220;

        let distance = 0;

        for (let i = 0; i < geos.length - 1; i++) {
            distance += this.computeDis(geos[i], geos[i + 1]);
        }

        distance = distance / 1000;
        let time = dates[dates.length - 1].getTime() - dates[0].getTime();

        time = time / 1000 / 60 / 60;

        return defaultSpeed * time / distance;
    }

    //旋轉向量XY平面
    rotateVectorXY(ang) {
        let v = window.gMainMap.TerrainView.camera.v;
        let arc = ang * Math.PI / 180;
        return new window.Geo3DPoint((Math.cos(arc) * v.x + Math.sin(arc) * v.y), (-Math.sin(arc) * v.x + Math.cos(arc) * v.y), 0)
    }

    //正規化
    normalize(vector) {
        let x2 = Math.pow(vector.x, 2);
        let y2 = Math.pow(vector.y, 2);
        let z2 = Math.pow(vector.z, 2);
        let unit = Math.sqrt(x2 + y2 + z2);

        return new window.Geo3DPoint(vector.x / unit, vector.y / unit, vector.z / unit);
    }

    //向量外積
    cross(v1, v2) {
        let x = v1.y * v2.z - v1.z * v2.y;
        let y = v1.z * v2.x - v1.x * v2.z;
        let z = v1.x * v2.y - v1.y * v2.x;

        return this.normalize({ x: x, y: y, z: z });
    }

    //計算角度
    computeAng(v1, v2) {
        let dot = v1.x * v2.x + v1.y * v2.y;
        let length = Math.sqrt(v1.x * v1.x + v1.y * v1.y) * Math.sqrt(v2.x * v2.x + v2.y * v2.y);

        let cos = dot.toFixed(10) / length.toFixed(10);

        return Math.acos(cos) * 180 / Math.PI;
    }

    //計算兩點距離
    computeDis(p1, p2) {
        let newP1 = new window.GeoPoint(p1.x, p1.y);
        let newP2 = new window.GeoPoint(p2.x, p2.y);
        engine.Transfer(4326, 3857, newP1);
        engine.Transfer(4326, 3857, newP2);
        let x2 = Math.pow(newP1.x - newP2.x, 2);
        let y2 = Math.pow(newP1.y - newP2.y, 2);

        return Math.sqrt(x2 + y2);
    }

    //判斷是否接近
    isClose(position, point, distance) {
        return this.computeDis(position, point) < distance;
    }

    //取得所有已儲存軌跡
    getAllTrack() {
        const { travelDiaryToolContext } = this.context;
        this.listLoading = true;
        ApiOviewDocmd.Docmd("CMD_GetTrackList", { token: travelDiaryToolContext.token }, (res) => {
            this.trackList = [];
            let showTrackList = [];
            let nowIndex = -1;
            res.list.forEach((track, index) => {
                if (track.dir !== "") {
                    nowIndex = index;
                }
                if (track.name.substring(0, track.name.length - 4) === (this.state.demoName)) {
                    this.demoIndex = index;
                    track.dir = "";
                }
                this.trackList.push(track);
                showTrackList.push(true);
            });
            if (nowIndex !== -1) {
                this.getTrack(nowIndex);
            }
            this.listLoading = false;
            this.setState({ showTrackList: showTrackList, nowTrackIndex: nowIndex }, () => { this.paintCluster(); })
        }, (res) => { this.listLoading = false; console.log(res); });
    }

    //輸出影片
    outputViedo_OnClick() {
        if (this.startVideo) {
            window.alertify.log("正在錄影中 請稍後。");
            return;
        }

        this.startVideo = true;

        let showList = [];
        this.nowEntityList.forEach((entity) => {
            showList.push(false);
        });

        this.recordTimelineEvent = window.gMainMap.TerrainView.addTimeEvent({
            start: this.GPXEntity.playingInfo.TimeSpan[0],
            end: this.GPXEntity.playingInfo.TimeSpan[1],
            onPlay: function () {
            }.bind(this),
            onEnter: function () {
                this.nowEntityList.forEach(entity => {
                    entity.point.show = true;
                });
            }.bind(this),
            onLeave: function () {
                this.widgetTimelinePlayer.stop();
            }.bind(this)
        });

        let dirName = `${new Date(Date.now()).toLocaleString('zh-TW', { timeZone: 'Asia/Taipei' }).replaceAll('/', '-').replaceAll(':', '.')}`;
        this.widgetTimeline.updateParameter({ isRepeat: false });

        let videoStream = window.gMainMap.TerrainView.canvas.captureStream(30);
        let mediaRecorder = new MediaRecorder(videoStream);
        let chunks = [];

        mediaRecorder.ondataavailable = function (e) {
            chunks.push(e.data);
        };

        mediaRecorder.onstop = function (e) {
            let blob = new Blob(chunks, { type: "video/mp4" });
            chunks = [];
            let videoURL = URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = videoURL;
            a.download = dirName + ".mp4";
            a.click();
            URL.revokeObjectURL(videoURL);
        };

        this.widgetTimelinePlayer.play();
        mediaRecorder.start();

        this.recordTimeEvent = setInterval(function () {
            if (this.widgetTimelinePlayer._Play || this.isPause) {
                mediaRecorder.requestData();
            }
            else {
                this.startVideo = false;
                window.alertify.success("輸出影片中");
                window.gMainMap.TerrainView.removeTimeEvent(this.recordTimelineEvent);
                this.widgetTimeline.updateParameter({ isRepeat: true });
                mediaRecorder.stop();
                clearInterval(this.recordTimeEvent);

                this.nowEntityList.forEach((entity, index) => {
                    entity.point.update({ text: this.nowPicList[index].title });
                    entity.border.show = false;
                    entity.picture.show = false;
                    entity.text.show = false;
                });
            }

        }.bind(this), 100);

        window.alertify.success("開始錄影，按下停止或時間到會輸出影片");
        window.alertify.log("錄影中請勿關閉視窗或挪動圖台以免錯誤");
    }

    //選擇照片(含座標)
    async picFile_OnChange(e) {
        if (!this.state.nowTrack) {
            window.alertify.log("請選擇軌跡檔案。");
            return;
        }

        if (e.target.files.length < 1) {
            window.alertify.log("請選擇檔案。");
            return;
        }

        let name = "";

        let nowTrack = this.state.nowTrack;
        let index = this.nowPicList.length;
        let oldIndex = index;
        let pointList = this.GPXEntity._entity.TrackManager.Stops;

        for (let i = 0; i < e.target.files.length; i++) {
            let file = e.target.files[i];
            let result = await exifr.parse(file);
            let gps = await exifr.gps(file);

            if (!gps) {
                console.log("no gps");
                continue;
            }

            let lat = gps.latitude;
            let lon = gps.longitude;
            let height = result.GPSAltitude;

            let geo = { x: lon, y: lat, z: height };
            let inTrack = false;
            let tooClose = false;

            for (let j = 0; j < pointList.length; j++) {
                if (this.isClose(pointList[j].Geo, geo, 1)) {
                    inTrack = true;
                    break;
                }
            }

            for (let j = 0; j < this.nowPicList.length; j++) {
                if (this.isClose(this.nowPicList[j].geo, geo, 10)) {
                    tooClose = true;
                    break;
                }
            }

            if (!inTrack) {
                window.alertify.log("照片座標不在軌跡上。");
                continue;
            }

            if (tooClose) {
                window.alertify.log("照片座標太接近現有照片。");
                continue;
            }

            const promise = new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = function () {
                    let res = reader.result;
                    resolve(res);
                }
                reader.readAsDataURL(file);
            });

            let uploadData = await promise;

            name += file.name;
            if (i < e.target.files.length - 1) {
                name += ",";
            }

            let fileName = file.name + `(${new Date(Date.now()).toLocaleString('zh-TW', { timeZone: 'Asia/Taipei' }).replaceAll('/', '-').replaceAll(':', '.')})`;
            let picEvent = { fileName: fileName, geo: geo, title: "旅圖日記" + index, text: "", pic: uploadData, update: true };
            this.addPicTimeList(geo);
            if (this.state.nowTrack.enable && this.state.nowTrack.dir !== "") {
                this.picUpload(picEvent, this.state.nowTrack.dir);
            }
            this.nowPicList.push(picEvent);
            this.nowEntityList.push(this.paintEvent(geo, uploadData, index));

            index++;
        }

        if (index > oldIndex) {
            window.alertify.success("上傳成功。");
        }

        this.setState({ nowTrack: nowTrack, picFileName: name, picEdit: false });
    }

    //選擇照片(不含座標)
    async picFileNoCoor_OnChange(e) {
        if (!this.state.nowTrack) {
            window.alertify.log("請選擇軌跡檔案。");
            return;
        }

        if (e.target.files.length < 1) {
            window.alertify.log("請選擇檔案。");
            return;
        }

        console.log(e.target.files);

        let name = "";

        let nowTrack = this.state.nowTrack;
        let index = this.nowPicList.length;
        let param = this.GPXEntity.getParameter();
        let trackGeoList = param.path.geo;
        let file = e.target.files[0];

        const promise = new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = function () {
                let res = reader.result;
                resolve(res);
            }
            reader.readAsDataURL(file);
        });

        let uploadData = await promise;

        window.alertify.success("點擊圖台加入照片。");

        window.gMainMap.TerrainView.inputSurfacePoint({
            onCompleted: function (result) {
                if (result.success) {
                    let point = result.geo;
                    let min = Number.MAX_VALUE;
                    let trackGeo = undefined;
                    for (let i = 0; i < trackGeoList.length - 1; i++) {
                        let dis = this.computeDis(trackGeoList[i], point);
                        if (dis < min) {
                            min = dis;
                            trackGeo = trackGeoList[i];
                        }
                    }

                    let tooClose = false;
                    for (let j = 0; j < this.nowPicList.length; j++) {
                        if (this.isClose(this.nowPicList[j].geo, trackGeo, 10)) {
                            tooClose = true;
                            break;
                        }
                    }

                    if (tooClose) {
                        window.alertify.log("照片座標太接近現有照片。");
                        trackGeo = undefined;
                    }

                    if (trackGeo) {
                        let geo = { x: trackGeo.x, y: trackGeo.y, z: 0 };

                        name += file.name;
                        let fileName = file.name + `(${new Date(Date.now()).toLocaleString('zh-TW', { timeZone: 'Asia/Taipei' }).replaceAll('/', '-').replaceAll(':', '.')})`;
                        let picEvent = { fileName: fileName, geo: geo, title: "旅圖日記" + index, text: "", pic: uploadData, update: true };
                        if (this.state.nowTrack.enable && this.state.nowTrack.dir !== "") {
                            this.picUpload(picEvent, this.state.nowTrack.dir);
                        }
                        this.nowPicList.push(picEvent);
                        this.nowEntityList.push(this.paintEvent(geo, uploadData, index));

                        this.addPicTimeList(geo);

                        this.setState({ nowTrack: nowTrack, picFileName: name, picEdit: false });
                    }
                    else {
                        window.alertify.log("上傳失敗。");
                    }
                }
                else {
                    window.alertify.log("上傳失敗。");
                }
            }.bind(this)
        });
    }

    //加入照片在軌跡的時間點
    addPicTimeList(picGeo) {
        let dates = this.GPXEntity.getParameter().path.date;
        let geo = this.GPXEntity.getParameter().path.geo;

        let minDis = this.computeDis(picGeo, geo[0]);
        let minInd = 0;

        for (let i = 0; i < geo.length - 1; i++) {
            let dis = this.computeDis(picGeo, geo[i]);
            if (minDis > dis) {
                minDis = dis
                minInd = i;
            }
        }

        this.nowEntityTimeList.push(dates[minInd]);
    }

    //上傳照片資料
    picUpload(picData, dir) {
        ApiOviewDocmd.Docmd("CMD_UploadPictureData", { picData: picData, dir: dir }, () => { }, () => { });
    }

    //刪除相片
    picDelete_OnClick() {
        if (this.state.nowTrack.dir === "") {
            this.deletePic();
            return;
        }

        ApiOviewDocmd.Docmd("CMD_DeleteTrackPicture", { fileName: this.nowPicList[this.state.showPicIndex].fileName, dir: this.state.nowTrack.dir },
            () => {
                this.deletePic();
            }, () => { }
        );
    }

    //刪除前端相片
    deletePic() {
        this.customPic.removeAllEntity();
        this.nowEntityList = [];
        this.nowPicList.splice(this.state.showPicIndex, 1);
        this.nowEntityTimeList.splice(this.state.showPicIndex, 1);

        this.nowPicList.forEach((pic, index) => {
            this.nowEntityList.push(this.paintEvent(pic.geo, pic.pic, index));
        });

        this.setState({ showPicIndex: -1, picEdit: false, picTitle: "", picText: "" });
    }

    //取得短網址
    async getShortURL_OnClick() {
        try {
            let shortUrl = window.location.origin + "/?token=" + this.state.nowTrack.dir;

            let textArea = document.createElement("textarea");
            textArea.value = shortUrl;
            //設為不可見
            textArea.style.position = "absolute";
            textArea.style.opacity = 0;
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand('copy');
            textArea.remove();
            window.alertify.log("網址已複製到剪貼簿");

        } catch (error) {
            console.log(error);
        }
    }

    //文字轉圖片
    textBecomeImg(text, fontcolor) {
        let canvas = document.createElement('canvas');

        let textNum = 14;
        let maxNum = 60;
        let fontsize = 20;
        let $buHeight = 5;

        let context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);
        canvas.width = 280;
        canvas.height = 150;
        context.fillStyle = fontcolor;
        context.font = fontsize + "px 微軟正黑體";

        context.textBaseline = 'middle';
        context.fillStyle = "#659aab";
        context.fillRect(0, 0, canvas.width, canvas.height)
        context.fillStyle = fontcolor;
        let line = 1;
        for (let i = 0; i < text.length; i += textNum) {
            if (i > maxNum) {
                break;
            }

            let height = (fontsize + $buHeight) * line;
            if (i + textNum <= text.length - 1) {
                context.fillText(text.substring(i, i + textNum), 0, height);
            }
            else {
                context.fillText(text.substring(i, text.length), 0, height);
            }
            line++;
        }

        let dataUrl = canvas.toDataURL('image/png');
        canvas.remove();
        return dataUrl;
    }

    //畫出日記點
    paintEvent(geo, picData, index) {
        let lon = geo.x;
        let lat = geo.y;
        //let height = window.gMainMap.TerrainView.getHeight(new window.GeoPoint(lon, lat));

        let pointEntity = this.customPic.addPushpinEntity({
            geo: new window.GeoPoint(lon, lat, 0),
            symbol: locate,
            text: this.nowPicList[index].title,
            font: "微軟正黑體",
            color: "#FFFFFF",
            size: 20,
            epsg: 4326,
            absHeight: false
        });

        let borderHeight = 150
        //圖片邊框
        let borderParam = {};
        borderParam.geo = new window.GeoPoint(lon, lat, 0);
        borderParam.color = "#FFFFFF";
        borderParam.epsg = 4326;
        borderParam.size = 20;
        borderParam.opacity = 1.0;
        borderParam.absHeight = false;
        borderParam.symbol = pictureBorder;
        borderParam.symbolSize = [600, 200];
        borderParam.pointOffset = new window.GeoPoint(-300, borderHeight);
        let borderEntity = this.customPic.addPointEntity(borderParam);

        let pictureEntity = this.customPic.addPointEntity({
            geo: new window.GeoPoint(lon, lat, 0),
            color: "#FFFFFF",
            size: 10,
            epsg: 4326,
            opacity: 1.0,
            absHeight: false,
            symbol: picData,
            symbolSize: [270, 170],
            minDisplayDistance: 0,
            pointOffset: new window.GeoPoint(-450, borderHeight),
        });

        let textImage = this.textBecomeImg(this.nowPicList[index].text, '#f1f1f1');
        let textEntity = this.customPic.addPointEntity({
            geo: new window.GeoPoint(lon, lat, 0),
            color: "#FFFFFF",
            epsg: 4326,
            opacity: 1.0,
            absHeight: false,
            symbol: textImage,
            symbolSize: [280, 150],
            label: { color: "#f1f1f1", text: "<" + this.nowPicList[index].title + ">", font: "微軟正黑體", size: 20, borderSize: 0, borderColor: "#00000000" },
            pointOffset: new window.GeoPoint(-160, borderHeight),
            labelOffset: new window.GeoPoint(-160, borderHeight - 5),
        });

        borderEntity.show = false;
        pictureEntity.show = false;
        textEntity.show = false;

        pointEntity.indexNum = index;

        pointEntity.setOnClickListener(function (pos, attr, SN) {
            this.showEntity(pointEntity.indexNum);
        }.bind(this));

        return { point: pointEntity, picture: pictureEntity, text: textEntity, border: borderEntity };
    }

    //顯示日記點照片
    showEntity(newIndex) {
        if (this.state.showPicIndex === newIndex) {
            this.nowEntityList[newIndex].picture.show = false;
            this.nowEntityList[newIndex].text.show = false;
            this.nowEntityList[newIndex].border.show = false;

            this.nowEntityList[newIndex].point.update({ text: this.nowPicList[newIndex].title });
            this.setState({ showPicIndex: -1, picTitle: "", picText: "", picText: "", nowPicture: picture });
            return;
        }

        let point = this.nowPicList[newIndex].geo;
        let lon = point.x;
        let lat = point.y;
        let height = window.gMainMap.TerrainView.getHeight(new window.GeoPoint(lon, lat));

        this.nowEntityList.forEach((entity, index) => {
            entity.point.update({ text: this.nowPicList[index].title });
            this.nowEntityList[newIndex].border.update({ absHeight: false });
            this.nowEntityList[newIndex].text.update({ absHeight: false });
            this.nowEntityList[newIndex].picture.update({ absHeight: false });
            entity.picture.show = false;
            entity.text.show = false;
            entity.border.show = false;
        });

        this.nowEntityList[newIndex].point.update({ text: "" });
        this.nowEntityList[newIndex].picture.show = true;
        this.nowEntityList[newIndex].text.show = true;
        this.nowEntityList[newIndex].border.show = true;

        this.nowEntityList[newIndex].border.update({ geo: new window.GeoPoint(lon, lat, height), absHeight: true });
        this.nowEntityList[newIndex].text.update({ geo: new window.GeoPoint(lon, lat, height), absHeight: true });
        this.nowEntityList[newIndex].picture.update({ geo: new window.GeoPoint(lon, lat, height), absHeight: true });
        /*this.nowEntityList[newIndex].border.update({ symbolSize: [0, 0], pointOffset: new window.GeoPoint(0, 0) });
        this.nowEntityList[newIndex].picture.update({ symbolSize: [0, 0], pointOffset: new window.GeoPoint(0, 0) });*/

        let title = this.nowPicList[newIndex].title;
        let text = this.nowPicList[newIndex].text;
        this.setState({ showPicIndex: newIndex, picEdit: false, picTitle: title, picText: text }, () => {/* this.showAnimate(this.nowEntityList[newIndex])*/ });
    }

    //顯示日記動畫
    /*showAnimate(entity) {
        let t = 0;
        let timePoint = setInterval(function () {

            if (t <= 10) {
                entity.border.update({
                    symbolSize: [20 * t + (2 * t * t) / 2, 30 * t + (6 * t * t) / 2],
                    pointOffset: new window.GeoPoint(-9 * t + (-1 * t * t) / 2, 20 * t + (2 * t * t) / 2)
                });
                entity.picture.update({
                    symbolSize: [13 * t + (1 * t * t) / 2, 3 * t + (1 * t * t) / 2],
                    pointOffset: new window.GeoPoint(-9 * t + (-1 * t * t) / 2, 23 * t + (5 * t * t) / 2)
                });
                t++;
            }
            else {
                entity.text.show = true;
                clearInterval(timePoint);
            }
        }.bind(this), 100);
    }*/

    //跳到特定點
    goto(x, y) {
        let geo = new window.GeoPoint(x, y);
        let height = window.gMainMap.TerrainView.getHeight(geo);
        let pos = new window.GeoPoint(geo.x, geo.y, height + 1500);
        let v = new window.Geo3DPoint(0, 0, -1);
        let up = new window.Geo3DPoint(0, 1, 0);
        let camera = new window.ov.Camera(pos, v, up);
        window.gMainMap.TerrainView.gotoCamera(camera, true, () => {
            camera.pos = new window.GeoPoint(geo.x, geo.y - 0.03, height + 1500);
            window.gMainMap.TerrainView.gotoCamera(camera, false);
            window.gMainMap.TerrainView.setVertArg(20);
        });
    }

    //跳到特定點 清單物件用
    listItem_goto(pos, targetIndex) {
        let height = window.gMainMap.TerrainView.getHeight(new GeoPoint(pos.x, pos.y)) + 2000;
        let camera = new window.ov.Camera(new Geo3DPoint(pos.x, pos.y, height), new Geo3DPoint(0, 0, -1), new Geo3DPoint(0, 1, 0));
        window.gMainMap.TerrainView.gotoCamera(camera, true, () => {
            camera.pos = new window.GeoPoint(pos.x, pos.y - 0.03, height);
            window.gMainMap.TerrainView.gotoCamera(camera, false);
            window.gMainMap.TerrainView.setVertArg(20);
        });

        let showTrackList = this.state.showTrackList;

        for (let i = 0; i < showTrackList.length; i++) {
            showTrackList[i] = false;
            if (i === targetIndex) {
                showTrackList[i] = true;
            }
        }

        this.custom.removeAllEntity();
        if (targetIndex !== this.state.nowTrackIndex) {
            this.customPic.removeAllEntity();
            this.removeTrack();
        }

        this.setState({ showTrackList: showTrackList }, () => { this.paintCluster(); });
    }

    //軌跡文字敘述更新
    editDescribe_OnClick() {
        let nowTrack = this.state.nowTrack;
        if (this.state.textEdit) {
            nowTrack.describe = this.state.describe;

            if (this.state.nowTrack.enable && this.state.nowTrack.dir !== "") {
                ApiOviewDocmd.Docmd("CMD_UpdateTrack", { describe: this.state.describe, dir: this.state.nowTrack.dir }, () => { }, () => { });
            }

            window.alertify.success("敘述已更新");
        }

        this.setState({ textEdit: !this.state.textEdit, nowTrack: nowTrack });
    }

    //相片編輯/存檔事件
    picture_Edit_OnClick() {
        if (this.state.picEdit) {
            if (this.state.picTitle === "") {
                window.alertify.error("標題不可為空");
                return;
            }

            //this.nowEntityList[this.state.showPicIndex].point.update({ text: this.state.picTitle });
            this.nowEntityList[this.state.showPicIndex].text.update({ symbol: this.textBecomeImg(this.state.picText, '#f1f1f1'), label: { text: "<" + this.state.picTitle + ">" } });
            this.nowPicList[this.state.showPicIndex].title = this.state.picTitle;
            this.nowPicList[this.state.showPicIndex].text = this.state.picText;
            this.nowPicList[this.state.showPicIndex].update = true;
        }

        if (this.state.nowTrack.enable && this.state.nowTrack.dir !== "") {
            ApiOviewDocmd.Docmd("CMD_UpdateTrackPicture", {
                fileName: this.nowPicList[this.state.showPicIndex].fileName,
                title: this.state.picTitle, text: this.state.picText, dir: this.state.nowTrack.dir
            }, () => { }, () => { });
        }

        this.setState({ picEdit: !this.state.picEdit });
    }

    //顯示軌跡點
    toggleTrackShow(index) {
        let showTrackList = this.state.showTrackList;
        showTrackList[index] = !showTrackList[index];
        this.custom.removeAllEntity();
        if (index === this.state.nowTrackIndex) {
            if (!showTrackList[index]) {
                this.customPic.removeAllEntity();
                this.removeTrack();
            }
            else {
                this.getTrack(index);
            }
        }

        this.setState({ showTrackList: showTrackList }, () => { this.paintCluster(); });
    }

    //切換分頁
    handleClick = (name) => {
        let pageName = this.state.pageName;

        switch (name) {
            case "日記": {
                pageName = "日記";
            }
                break;
            case "日記編輯": {
                if (this.state.nowTrack) {
                    pageName = "日記編輯";
                }
                break;
            }
            case "清單": {
                pageName = "清單";
                break;
            }
        }

        if (this.state.nowTrack) {
            let title = this.state.picTitle;
            let text = this.state.picText;
            if (this.state.showPicIndex !== -1) {
                title = this.nowPicList[this.state.showPicIndex].title;
                text = this.nowPicList[this.state.showPicIndex].text
            }
            this.setState({
                pageName: pageName,
                describe: this.state.nowTrack.describe,
                textEdit: false,
                picEdit: false,
                picText: text,
                picTitle: title,
            });
        }
        else {
            this.setState({ pageName: pageName });
        }
    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <DraggableWindow
                header="旅圖日記"
                content={this.content()}
                width={this.props.width}
                height={this.props.height}
                defaultPosition={this.props.defaultPosition}
                handleMinimize={this.props.handleMinimize}
                handleCancel={this.props.handleCancel}
                isShow={this.props.isShow} />
        );
    }

    //軌跡故事編輯版面
    trackText_EditPanel() {
        if (this.state.nowTrack) {
            if (this.state.nowTrack.enable && this.state.textEdit) {
                return (
                    <textarea
                        rows="6"
                        cols="50"
                        value={this.state.describe}
                        style={{ resize: "none", height: "100px", width: "90%", alignSelf: "center", backgroundColor: "#f2dbdb", margin: "0 20px" }}
                        onChange={(e) => { e.persist(); this.setState({ describe: e.target.value }); }}
                    />
                );
            }
        }

        return (<div className="travelDiaryTool-textArea" style={{ margin: "0 20px" }}>{this.state.describe}</div>);
    }

    //軌跡上傳頁面
    update_Panel() {
        return (
            <div className="travelDiaryToolBox">
                <div className='travelDiaryTool-row'>
                    <span>GPX選擇:</span>
                    <input type="text"
                        className='travelDiaryTool-text'
                        style={{ backgroundColor: "#f2dbdb" }}
                        value={this.state.gpxFileName != "" ? this.state.gpxFileName : ""}
                        disabled
                    />
                    <label className='travelDiaryTool-btn'>
                        選擇
                        <input
                            type="file"
                            style={{ width: "1px", height: "1px" }}
                            placeholder="with a placeholder"
                            accept=".gpx"
                            onChange={(e) => { e.persist(); this.gpxFile_OnChange(e); }}
                        />
                    </label>
                </div>
                <div className='travelDiaryTool-row' style={{ margin: 0, padding: 0, fontSize: "0.5em" }}>
                    <span>採用WGS84經緯度坐標系</span>
                </div>
                {this.state.nowTrack && this.state.nowTrack.enable ?
                    <div className='travelDiaryTool-row'>
                        <span>照片選擇:</span>
                        <input type="text"
                            className='travelDiaryTool-text'
                            style={{ backgroundColor: "#f2dbdb" }}
                            value={this.state.picFileName}
                            disabled
                        />
                        <label className='travelDiaryTool-btn'>
                            有坐標
                            <input
                                type="file"
                                style={{ width: "1px", height: "1px" }}
                                placeholder="with a placeholder"
                                accept=".jpg, .png"
                                multiple
                                onChange={(e) => { e.persist(); this.picFile_OnChange(e); }}
                            />
                        </label>
                        <label className='travelDiaryTool-btn'>
                            自訂
                            <input
                                type="file"
                                style={{ width: "1px", height: "1px" }}
                                placeholder="with a placeholder"
                                accept=".jpg, .png"
                                onChange={(e) => { e.persist(); this.picFileNoCoor_OnChange(e); }}
                            />
                        </label>
                    </div> : null}
                <div className='travelDiaryTool-col'>
                    <span>軌跡故事:</span>
                    {
                        this.trackText_EditPanel()
                    }
                </div>
                {this.state.nowTrack ?
                    <div className='travelDiaryTool-row' style={{ alignItems: "flex-start", justifyContent: "space-between" }}>
                        <div>
                            <img className="travelDiaryTool-func" src={outputVideo} width="50" height="50" alt="outputVideo" onClick={() => { this.outputViedo_OnClick(); }} />
                            {this.state.nowTrack.enable && this.state.nowTrack.dir !== "" ?
                                <img className="travelDiaryTool-func" src={shared} width="50" height="50" alt="shared" onClick={() => { this.getShortURL_OnClick(); }} /> : null
                            }
                        </div>
                        {this.state.nowTrack.enable ?
                            <div>{this.state.uploadLoading ? <img src={loading} alt="loading" /> :
                                this.state.nowTrack.dir === "" ?
                                    <button className="travelDiaryTool-btn" onClick={() => { this.uploadTrack_OnClick(); }}>上傳</button> :
                                    <button className="travelDiaryTool-btn" onClick={() => { this.deleteTrack_OnClick(); }}>刪除</button>
                            }
                                <label className='travelDiaryTool-btn' onClick={(e) => { this.editDescribe_OnClick(); }}>{this.state.textEdit ? "存檔" : "編輯"}</label>
                            </div> : null
                        }
                    </div> : null
                }
            </div>
        );
    }

    //相片標題編輯區域
    picture_EditTitle() {
        if (this.state.nowTrack) {
            if (this.state.nowTrack.enable && this.state.picEdit) {
                return (
                    <input type="text"
                        value={this.state.picTitle}
                        style={{ marginLeft: "18px", border: "groove" }}
                        className='travelDiaryTool-text'
                        placeholder="請輸入標題"
                        onChange={(e) => { this.setState({ picTitle: e.target.value }); }}
                    />
                );
            }
        }

        return (<span style={{ marginLeft: "18px" }} className='travelDiaryTool-header'>{this.state.picTitle}</span>);
    }

    //相片故事編輯區域
    picture_EditText() {
        if (this.state.nowTrack) {
            if (this.state.nowTrack.enable && this.state.picEdit) {
                return (
                    <textarea
                        className="travelDiaryTool-textArea"
                        rows="6"
                        cols="50"
                        style={{ resize: "none", height: "100px", width: "90%", alignSelf: "center", border: "groove", backgroundColor: "#fdf8f8" }}
                        value={this.state.picText}
                        onChange={(e) => { this.setState({ picText: e.target.value }); }}
                    />
                );
            }
        }

        return (
            <div className="travelDiaryTool-textArea" style={{ backgroundColor: "#fdf8f8", marginLeft: "18px", marginRight: "23px" }}>
                {this.state.picText}
            </div>
        );
    }

    //相片編輯頁面
    picture_Panel() {
        return (
            <div className="travelDiaryToolBox" style={{ backgroundColor: "#FFF" }}>
                <div className='travelDiaryTool-row'>
                    <img className='travelDiaryTool-img' src={this.state.showPicIndex !== -1 ? this.nowPicList[this.state.showPicIndex].pic : picture/*this.state.nowPicture*/} width="400" height="300" alt="" />
                </div>
                <div className='travelDiaryTool-row' style={{ justifyContent: "flex-start" }} >
                    {
                        this.picture_EditTitle()
                    }
                </div>
                <div className='travelDiaryTool-col'>
                    {
                        this.picture_EditText()
                    }
                </div>
                {this.state.nowTrack.enable && this.state.showPicIndex !== -1 ?
                    <div className='travelDiaryTool-row' style={{ justifyContent: "flex-end" }}>
                        <button className="travelDiaryTool-btn" onClick={() => { this.picture_Edit_OnClick(); }}>{this.state.picEdit ? "存檔" : "編輯"}</button>
                        <button className="travelDiaryTool-btn" onClick={() => { this.picDelete_OnClick(); }}>刪除</button>
                    </div>
                    : null}
            </div>
        );
    }

    //軌跡清單
    list_Panel() {
        return (
            <div className="travelDiaryToolBox">
                <div className='travelDiaryTool-col' style={{
                    padding: "5px", border: "1px solid black",
                    backgroundImage: "linear-gradient(to bottom, #8cc4c2 -16%, #91c7f1 62%)"
                }}>
                    <span>範例:</span>
                    {
                        this.demoIndex !== -1 && this.trackList[this.demoIndex] ?
                            <TravelDiaryListItem
                                name={this.trackList[this.demoIndex].name} pos={this.trackList[this.demoIndex].pos} index={this.demoIndex}
                                userDelete={this.loginUserDelete_OnClick.bind(this)}
                                isDelete={false}
                                goto={this.listItem_goto.bind(this)}
                                show={this.state.showTrackList[this.demoIndex]} setShow={this.toggleTrackShow.bind(this)} /> : null
                    }
                </div>
                <div className='travelDiaryTool-col'>
                    {
                        this.trackList.map((track, index) => {
                            if (index === this.demoIndex) {
                                return null;
                            }
                            return (<TravelDiaryListItem key={track.name + "" + index}
                                name={track.name} pos={track.pos} index={index}
                                isDelete={this.state.isLogined}
                                userDelete={this.loginUserDelete_OnClick.bind(this)}
                                goto={this.listItem_goto.bind(this)}
                                show={this.state.showTrackList[index]} setShow={this.toggleTrackShow.bind(this)} />)
                        })
                    }
                </div>
            </div>
        );
    }

    content() {
        return (
            <div className='travelDiaryTool'>
                <div className="travelDiaryToolItem-box">
                    <TravelDiaryToolItem name={"日記"} handleClick={this.handleClick} checkedName={this.state.pageName} />
                    {
                        this.state.nowTrack ? <TravelDiaryToolItem name={"日記編輯"} handleClick={this.handleClick} checkedName={this.state.pageName} /> : null
                    }
                    <TravelDiaryToolItem name={"清單"} handleClick={this.handleClick} checkedName={this.state.pageName} />
                </div>
                {this.state.pageName === "日記" ? this.update_Panel() : null}
                {this.state.pageName === "日記編輯" ? this.picture_Panel() : null}
                {this.state.pageName === "清單" ? this.list_Panel() : null}
            </div>
        );
    }
}